import {
  LOGOUT,
  LOADING,
  DISPLAY_FULL_SIDEBAR,
  DISPLAY_NOTIFICATION_BAR,
  LOGGED_IN_USER_DATA_REQUEST,
  LOGGED_IN_USER_DATA_SUCCESS,
  UPDATE_DEVICE_TYPE,
  FIRST_TIME_LOGGED_IN,
  DISPLAY_INFRA_BANNER,
  DISPLAY_FULL_DATASET_SIDEBAR,
  UPLOAD_TRACKER,
  UPDATE_SOCKET_ID,
  UPDATE_MODEL_URL,
  SET_APP_CONTAINER
} from './constants';
import { revokeSession } from 'api/session';

const getCurrentDevice = ({ width }) => {
  // if (isMobile) {
  //   return 'mobile'
  // }
  if (width <= 575.98) return 'mobile';
  if (width > 575.98 && width < 991.97) return 'tablet';
  if (width > 991.98) return 'desktop';
  return 'desktop';
};

export const logout = () => {
  const refreshToken = sessionStorage.getItem('refreshToken');
  const accessToken = sessionStorage.getItem('accessToken');
  revokeSession(refreshToken, accessToken).catch(() => {
    // Local logout should still complete if the revocation request is unavailable.
  });

  return {
    type: LOGOUT,
  };
};

export const setAppContainer = (ref) => ({
  type: SET_APP_CONTAINER,
  payload: ref
});

export const setLoading = loading => ({
  type: LOADING,
  loading,
});

export function updateNotificationDisplay(payload) {
  return {
    type: DISPLAY_NOTIFICATION_BAR,
    payload,
  };
}

export function updateInfraBanner(payload) {
  return {
    type: DISPLAY_INFRA_BANNER,
    payload,
  };
}

export function isFirstLoggedIn(payload) {
  return {
    type: FIRST_TIME_LOGGED_IN,
    payload,
  };
}

export function updateDeviceType(payload) {
  return {
    type: UPDATE_DEVICE_TYPE,
    payload: getCurrentDevice(payload),
  };
}

export function updateSidebarDisplay(payload) {
  return {
    type: DISPLAY_FULL_SIDEBAR,
    payload,
  };
}

export function updateDatasetSidebarDisplay(payload) {
  return {
    type: DISPLAY_FULL_DATASET_SIDEBAR,
    payload,
  };
}

export function loggedInUserDataRequest(payload) {
  return {
    type: LOGGED_IN_USER_DATA_REQUEST,
    payload,
  };
}

export function loggedInUserDataSuccess(payload) {
  return {
    type: LOGGED_IN_USER_DATA_SUCCESS,
    payload,
  };
}

export function uploadTracker(payload, meta) {
  return {
    type: UPLOAD_TRACKER,
    payload,
    meta
  };
}

export function updateSocketId(payload) {
  return {
    type: UPDATE_SOCKET_ID,
    payload,
  };
}

export function addModelImage(payload) {
  let buildPayload = {}

  const rawPayload = payload && payload.payload;

  if (rawPayload) {
    let meta = null;

    if (typeof rawPayload === 'string') {
      try {
        meta = JSON.parse(rawPayload);
      } catch (e) {
        meta = null;
      }
    } else if (rawPayload instanceof ArrayBuffer || (rawPayload.byteLength && rawPayload.buffer)) {
      try {
        const uint8 = rawPayload instanceof Uint8Array ? rawPayload : new Uint8Array(rawPayload);
        if (uint8.byteLength >= 4) {
          const view = new DataView(uint8.buffer, uint8.byteOffset, uint8.byteLength);
          const metaLen = view.getUint32(0);
          if (metaLen > 0 && 4 + metaLen <= uint8.byteLength) {
            const metadataBytes = uint8.slice(4, 4 + metaLen);
            const decoder = new TextDecoder();
            const metadataJson = decoder.decode(metadataBytes);
            meta = JSON.parse(metadataJson);
          }
        }
      } catch (e) {
        meta = null;
      }
    } else if (typeof rawPayload === 'object') {
      meta = rawPayload;
    }

    if (meta) {
      buildPayload = {
        label: payload.message,
        current: meta.current_frame,
        total: meta.total_frames
      }
    }
  }

  return {
    type: UPDATE_MODEL_URL,
    payload: buildPayload
  };
}